<template>
    <div class="card">
		<div class="card__header">
			<h5 class="card__title">Список лидеров</h5>
		</div>
		<div class="table-wrap">
			<table class="table table--bordered">
				<thead>
					<tr>
						<th class="text-center th--short">#</th>
						<th>Игрок</th>
						<th>Выигрыш</th>
						<th>Выиграно в Казино</th>
						<th>Выиграно в Режимах</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(localUser, index) in users" :class="{'table-success': user && localUser.id == user.id }">
						<td class="text-center"><b>{{ index + 1 }}</b></td>
						<td>{{ localUser.username }}</td>
						<td>{{ $root.shortLargeNumber(localUser.total) }} ₽</td>
						<td>{{ $root.shortLargeNumber(localUser.casino) }} ₽</td>
						<td>{{ $root.shortLargeNumber(localUser.games) }} ₽</td>
					</tr>
				</tbody>
			</table>
		</div>
    </div>
</template>

<script>
	import { useUserStore } from '../../stores/User';
	import {mapState} from "pinia";

    export default {
        data() {
            return {
                users: []
            }
        },
		computed: {
			...mapState(useUserStore, ['user']),
		},
        methods: {
            fillTable() {
                this.$root.axios.get('/api/user/stats')
                    .then(res => {
                        const data = res.data;
                        this.users = data.users;

                        this.$root.isLoading = false;
                    });
            },
        },
        beforeMount() {
            this.$root.isLoading = true;

            this.fillTable()
        }
    }
</script>